import { UnassignedOrderCounts } from '@services';
import { useStore } from '@stores';
import { useEffect } from 'react';

/**
 * The side panel's Jobs badge, unfiltered: one count per list (see UnassignedOrderScope). The
 * caller adds up the lists its view can actually reach - the week and month grids draw the dated
 * jobs themselves, so there the badge is the Unscheduled count alone.
 */
export const useUnAssignedCount = (): { counts: UnassignedOrderCounts } => {
  const { orderStore } = useStore();

  useEffect(() => {
    orderStore.getUnAssignedCount();
  }, [orderStore]);

  return { counts: orderStore.unAssignedCounts };
};
